<script setup>
import {watch, reactive} from 'vue';
import {store} from '@/store';
import { getUserByUid } from '@/firebase_files/user_functions';
import SpinnerWheel from './SpinnerWheel.vue';

const s = store;
const state = reactive({
  userObject: null,
});

let counter = 0; // padding to make sure we don't run into an infite loop

watch(()=>store.user, async (newVal, oldVal) => {
  counter++;
  if (counter > 10) {
    console.log('infinite loop');
    return;
  }

  const s = store;


});





</script>

<template>
  <div class="spinner-container">
    <SpinnerWheel />
  </div>
</template>
<style lang="scss" scoped>
.spinner-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
}
</style>
